var key = 'AIzaSyCpoMj0pdTZzHlX3cxdHFPaybONYl5uJMI';


export default key;



// WEBPACK FOOTER //
// ./src/config/key.js